import React, { Component } from 'react';

export default class AccordionContainer extends Component {
    state = {
        expandedId: null,
    };

    onExpand = (key) => {
        this.setState({ expandedId: key });
    };

    render() {
        const { expandedId } = this.state;
        const { children } = this.props;

        const clones = React.Children.toArray(children);

        return (
            <React.Fragment>
                {clones.map((elem) =>
                    React.cloneElement(elem, {
                        expanded: expandedId === elem.props.accordionKey,
                        onExpand: this.onExpand,
                    })
                )}
            </React.Fragment>
        );
    }
}
